import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { Container } from "../Container/Container";
import { Button } from "../Button/Button";
import { MenuIcon } from "@/icons/MenuIcon";
import { XIcon } from "@/icons/XIcon";
import styles from "./NavBar.module.css";

export function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  function goToSignup() {
    navigate("/signup");
  }

  return (
    <header className={styles.header}>
      <Container>
        <nav className={styles.nav}>
          <Link to="/" className={styles.logo} aria-label="TidyRota home">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              aria-hidden="true"
            >
              <rect width="28" height="28" rx="6" fill="var(--color-accent-solid)" />
              <path
                d="M8 14.5L12 18.5L20 10.5"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={styles.wordmark}>TidyRota</span>
          </Link>

          <div className={styles.desktopLinks}>
            <a href="#pricing" className={styles.link}>
              Pricing
            </a>
            <Link to="/login" className={styles.link}>
              Log in
            </Link>
            <Button size="sm" onClick={goToSignup}>
              Start free trial
            </Button>
          </div>

          <button
            className={styles.menuButton}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <XIcon width={24} height={24} /> : <MenuIcon width={24} height={24} />}
          </button>
        </nav>
      </Container>

      {menuOpen && (
        <div className={styles.mobileMenu} role="dialog" aria-label="Navigation menu">
          <nav className={styles.mobileNav}>
            <a
              href="#pricing"
              className={styles.mobileLink}
              onClick={() => setMenuOpen(false)}
            >
              Pricing
            </a>
            <Link
              to="/login"
              className={styles.mobileLink}
              onClick={() => setMenuOpen(false)}
            >
              Log in
            </Link>
            <Button
              size="lg"
              className={styles.mobileCta}
              onClick={() => { setMenuOpen(false); goToSignup(); }}
            >
              Start free trial
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
}
